import { IMedia } from '@/interfaces';
import styles from '../..//blog/blog.module.css';
import Image from 'next/image';
type props = {
    data: IMedia
}
export function MediaTile({ data }: props) {
    return (
        <a href={data.news_link} target='_blank'>
            <div>
                <div className={styles.blog_box}>
                    <div className={styles.blog_img}>
                        <Image src={data.thumbnail_image || "/assets/images/blog1.jpg"} alt={data.title} height={254} width={400} />
                    </div>
                    <div className={styles.blog_content}>
                        <div className={styles.blog_user}>
                            <span>
                                <i>
                                    <Image src={data.media_logo || "/assets/images/daily-hunt.jpg"} height={43} width={43} alt='' />
                                </i>{data.media_house}</span>
                            <span>{data.news_date}</span>
                        </div>
                        <div>
                            <h3>{data.title}</h3>
                            <p>{data.description}</p>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    )
}